/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProductApprovalCheckStepDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    readonly productApprovalId?: string;
    checkStepType: ProductApprovalCheckStepDto.checkStepType;
    comment?: string;
    notice?: string;
};
export namespace ProductApprovalCheckStepDto {
    export enum checkStepType {
        TECHNICAL_EXAMINATION = 'TECHNICAL_EXAMINATION',
        RELEASE_ENGAGEMENT = 'RELEASE_ENGAGEMENT',
        INVOICE = 'INVOICE',
        CERTIFICATE = 'CERTIFICATE',
    }
}

